import React, { useRef, useState } from "react";
import Button from "@components/buttons/Button/Button";
import PopupCard from "@components/modals/PopupCard/PopupCard";
import QRCode, { QRCodeHandle } from "@components/display/QRCode/QRCode";
import PrivacyToggleSwitch from "@components/controls/PrivacyToggleSwitch/PrivacyToggleSwitch";
import styles from "./QRCodePopup.module.css";

interface QRCodePopupProps {
    visible: boolean;
    memorialId: string;
    qrKey: string;
    downloadFileName?: string;
    onClose: () => void;
}

const IMAGE_SIZE = 300;

const QRCodePopup: React.FC<QRCodePopupProps> = ({
    visible, memorialId, qrKey, downloadFileName, onClose,
}) => {
    const qrRef = useRef<QRCodeHandle>(null);
    const [isPrivate, setIsPrivate] = useState(true);

    const handleDownload = () => {
        qrRef.current?.download();
    };

    return (
        <PopupCard visible={visible} onClose={onClose}>
            <p className={styles.text}>Display this QR code on service materials to allow attendees to access the memorial.</p>
            <PrivacyToggleSwitch isPrivate={isPrivate} onToggle={(val) => setIsPrivate(val)} />
            <p className={styles.text}>Public QR code does not allow access to QR protected sections. Both private and public QR codes can be used.</p>
            <QRCode
                ref={qrRef}
                // Keep /1 as qrkey so destination knows it is from qr code
                value={`http://fioh.au/${memorialId}${isPrivate ? `/${qrKey}` : "/1"}`}
                size={IMAGE_SIZE}
                downloadFileName={`${downloadFileName}_${isPrivate ? "private" : "public"}`}
                logoWidthMultiplier={isPrivate ? 0.21 : 0.24}
            />
            <p className={styles.text}>To add privacy controls, visit the privacy section in the memorial editor.</p>
            <p className={styles.text}><b>Note</b>: It is recommended to print this QR code minimum 20x20mm at 300 DPI.</p>
            <div className={styles.buttonGroup}>
                <Button variant="secondary" size="medium" onClick={onClose}>
                    Close
                </Button>
                <Button variant="primary" size="medium" onClick={handleDownload}>
                    Download
                </Button>
            </div>
        </PopupCard>
    );
};

export default QRCodePopup;
